<template lang="pug">
.loaderComponent(:style="spinnerStyles")
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20
    },
    borderWidth: {
      type: Number,
      default: 4
    },
    isResponsive: Boolean
  },
  computed: {
    spinnerStyles () {
      return {
        width: this.isResponsive ? '100%' : `${this.size}px`,
        height: this.isResponsive ? '100%' : `${this.size}px`,
        borderWidth: `${this.borderWidth}px`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.loaderComponent
  border-radius: 50%
  border: solid
  animation: spinner 1s infinite linear
  margin: auto

  border-color: rgba(#314190, 0.2)
  border-left-color: #314190

@keyframes spinner
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)
</style>
